import react, { useEffect, useState } from "react";
import ComponentCard from "../../../../components/common/ComponentCard";
import Button from "../../../../components/ui/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "../../../../components/form/Form";
import Label from "../../../../components/form/Label";
import Select from "../../../../components/form/Select";
import Input from "../../../../components/form/input/InputField";
import Switch from "../../../../components/form/switch/Switch";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateWorkflowCategories() {
  const navigate = useNavigate();
  const location = useLocation();
  const category = location.state?.category;

  const [formData, setFormData] = useState({
    name: "",
    status: "",
    temperatureCheck: false,
  });

  const [errors, setErrors] = useState({
    name: "",
    status: "",
  });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || "",
        status: category.status === 1 ? "Current" : "Non-Current",
        temperatureCheck: category.temperature_check === 1,
      });
    }
  } , [category]);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectChange = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };
  
  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Venue Area name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    // Submit updated data to API or data source
    try {
      const token = localStorage.getItem("token");
      const payload = {
        category_id: category.acwfcategory_id,
        name: formData.name,
        status: formData.status,
        temperatureCheck: formData.temperatureCheck,
      };

      console.log("Payload:", payload);
      
      
      const response = await fetch(`${apiUrl}/workflows_categories`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log(result);
      if (result.success) {
        navigate("/workflow-categories");
      }
    } catch (error) {
      console.error("Error updating workflow category:", error);
    }
    
  };

  const handleCancel = () => {
    navigate("/workflow-categories");
  };

  //Handle temperature check switch
  const handleTemperatureCheckChange = (checked: boolean) => {
    setFormData({
      ...formData,
      temperatureCheck: checked,
    });
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this workflow category?")) return;
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/workflows_categories/${category.acwfcategory_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        }
      );
      if (response.ok) {
        navigate("/workflow-categories");
      } else {
        console.error("Failed to delete workflow category");
      }
    } catch (error) {
      console.error("Error deleting workflow category:", error);
    }
  };

  return(
    <>
      <ComponentCard title="Add New Venue Area">
        <Form onSubmit={handleSubmit}>
          <>
            <div className="grid gap-6">
              <div className="col-span-full">
                <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                    Workflow Category
                </h4>
              </div>
              {/* Venue Area Name */}
              <div>
                <Label>Workflow Category</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
              </div>
              {/* Record Status */} 
              <div>
                <Label>Record Status</Label>
                <Select
                  options={[
                    { value: "Current", label: "Current" },
                    { value: "Non-Current", label: "Non-Current" },
                  ]}
                  value={formData.status}
                  onChange={handleSelectChange}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>

              {/* Auto Renewal Switch */}
              <Switch
                label="Temperature Check"
                checked={formData.temperatureCheck}
                onChange={(checked: boolean) => handleTemperatureCheckChange(checked)}
              />

              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Update Changes
                </Button>
                <Button size="sm" variant="outline" onClick={handleCancel} type="button">
                  Cancel
                </Button>
                <button className="px-4 py-3 text-sm font-medium text-white rounded-lg bg-error-800 shadow-theme-xs hover:bg-error-600" onClick={handleDelete}>
                  Delete
                </button>
              </div>
            </div>
          </>
        </Form>
      </ComponentCard>
    
    </>
  )
};